import { render } from "./qr.html?vue&type=template&id=5240ac3a&scoped=true&ts=true&external"
import script from "./QR.vue?vue&type=script&lang=ts"
export * from "./QR.vue?vue&type=script&lang=ts"

import "./QR.vue?vue&type=style&index=0&id=5240ac3a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5240ac3a"]])

export default __exports__